import React, { useState } from "react";
import styled from "styled-components";
import { MdMenu } from "react-icons/md";
import Modal from "@mui/material/Modal";
import Collapse from "@mui/material/Collapse";
// import { useTranslation } from "react-i18next";
import { Title, Content } from "../Components/Typo";

const Parent = styled.div`
  background-image: url("earth.jpg");
  background-position: center;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: left;
`;

const Iframe = styled.iframe`
  flex: 0.75;
  height: 100%;
  overflow: hidden;
`;

const Description = styled.div`
  color: #fff;
  height: 100%;
  backdrop-filter: blur(10px);
  overflow: hidden;
  padding: 20px;
`;

const CollapseStyled = styled(Collapse)`
  flex: 0.25;
  height: 100%;
  backdrop-filter: blur(10px);
  overflow: hidden;
  padding: 20px;
`;

const Menu = styled(MdMenu)`
  position: absolute;
  font-size: 30px;
  color: #fff;
  top: 40px;
  right: 15px;
  z-index: 10;
  cursor: pointer;
  display: none;
`;

const Section = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
`;

const Image = styled.img`
  width: 100px;
  height: 75px;
  cursor: zoom-in;
  margin: 5px;
  border: ${(props) => (props.bordering ? "2px red solid" : "0px red solid")};
`;

const Background = styled.img`
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 300px;
  border-radius: 10px;
`;

const ModalStyled = styled(Modal)`
  backdrop-filter: blur(2px);
`;

export default function ParkerProbe() {
  const [collapse, setCollapse] = useState(true);
  const [url, setUrl] = useState(null);
  // const { t } = useTranslation();
  const images = [
    {
      src: "parker-dimension.jpg",
      alt: "parker probe dimension",
    },
    {
      src: "parker-element.jpg",
      alt: "parker probe élement",
    },
    {
      src: "parker-fast.jpg",
      alt: "parker probe rapide",
    },
  ];
  return (
    <Parent>
      <ModalStyled
        open={url !== null}
        onClose={() => setUrl(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Background src={url} />
      </ModalStyled>
      <Menu onClick={() => setCollapse(true)} />
      <Iframe
        title="La sonde Parker Solar Probe"
        frameborder="0"
        allowfullscreen
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
        allow="autoplay; fullscreen; xr-spatial-tracking"
        xr-spatial-tracking
        execution-while-out-of-viewport
        execution-while-not-rendered
        web-share
        src="https://sketchfab.com/models/677db8e471174f02b470518f9427f66f/embed"
      />
      <CollapseStyled orientation="horizontal" in={collapse}>
        <Description>
          <Title>The Parker Solar Probe</Title>
          <Content>
            The Parker Solar Probe, launched in 2018, successfully completed the
            closest flyby of the Sun ever made on April 29, 2020, brushing the
            star 10.4 million kilometers away, and recorded the fastest speed of
            a man-made object, spinning at 532,000 km/h, or 148 kilometers per
            second.
          </Content>
          {/* <Subtitle>Illustrations</Subtitle> */}
          <Section>
            {images.map((image) => {
              return (
                <Image
                  onClick={() => setUrl(image.src)}
                  src={image.src}
                  bordering={url === image.src}
                  alt={image.alt}
                />
              );
            })}
          </Section>
        </Description>
      </CollapseStyled>
    </Parent>
  );
}
